import { z } from 'zod';
/**
 * Пространство — сайт Jira, к которому человек подключён. Один аккаунт Atlassian может открывать
 * несколько сайтов сразу, поэтому в Jisy их столько же, и переключатель в шапке ходит между ними.
 */
export const WorkspaceSchema = z.object({
    tenantId: z.string(),
    cloudId: z.string(),
    siteName: z.string(),
    siteUrl: z.string(),
    avatarUrl: z.string().nullable(),
    role: z.enum(['admin', 'member']),
    /** Пространство текущей сессии: в списке отмечено галочкой и не переключается. */
    current: z.boolean(),
    /**
     * Доступ отозван или в пространстве не осталось подключений. Войти в такое нельзя — сессия
     * в отключённом тенанте не разрешается, — поэтому вместо переключения предлагается
     * переподключение через Atlassian.
     */
    needsReconnect: z.boolean(),
});
export const WorkspaceListSchema = z.object({ workspaces: z.array(WorkspaceSchema) });
/**
 * Сайт, который выданный токен уже открывает, но в Jisy он ещё не подключён. Такой сайт
 * подключается одним нажатием: ходить в Atlassian за новым согласием незачем.
 */
export const AvailableSiteSchema = z.object({
    cloudId: z.string(),
    name: z.string(),
    url: z.string(),
    avatarUrl: z.string().nullable(),
});
export const AvailableSitesSchema = z.object({ sites: z.array(AvailableSiteSchema) });
export const WorkspaceConnectSchema = z.object({ cloudId: z.string().min(1).max(128) });
/**
 * Куда человек попадает после отключения. Отключиться можно и от того пространства, в котором
 * сейчас работаешь: тогда сессия выпускается в следующее подключённое, а если такого нет —
 * гасится вовсе, и клиент уходит на экран подключения.
 */
export const WorkspaceDisconnectResultSchema = z.object({
    switchedTo: z.string().nullable(),
});
//# sourceMappingURL=workspaces.js.map